import axios from "axios";
import { getPresignedURL } from "../../../Services/Welder-services";
import { emptyError, emptyErrorWPQDetail, addWeldingValidUptoDate } from "./WPQCommonUtils";

// Re-export for backward compatibility
export { emptyError };
export { emptyErrorWPQDetail };
export { addWeldingValidUptoDate as addWedlingValidUptoDate };

export const emptyErrorWPQDetailTubesheet = (err, seterr, iserror) => {
  let entries = Object.keys(err);
  entries.forEach((i) => {
    let value = err[i]
    if (Array.isArray(value)) {
      let errmessage = process.env.REACT_APP_SPECIAL_CHARACTER_MSG
      if (err[i][0].Value_A[0].message === errmessage || err[i][1].Value_B[0].message === errmessage) {
        iserror = true
        seterr((prevState) => ({
          ...prevState,
          [entries]: [
            {
              Value_A: [{
                status: true,
                message: process.env.REACT_APP_SPECIAL_CHARACTER_MSG
              }]
            },
            {
              Value_B: [{
                status: true,
                message: process.env.REACT_APP_SPECIAL_CHARACTER_MSG
              }]
            },
          ],
        }));
      }
      else {
        seterr((prevState) => ({
          ...prevState,
          [entries]: [
            {
              Value_A: [{
                status: false,
                message: ""
              }]
            },
            {
              Value_B: [{
                status: false,
                message: ""
              }]
            },
          ],
        }));
      }
    }
    else {
      if (err[i].message === process.env.REACT_APP_SPECIAL_CHARACTER_MSG) {
        iserror = true
        err[i] = {
          status: true,
          message: err[i].message,
        };
      }
      else {
        err[i] = {
          status: false,
          message: ``,
        };
      }
      seterr((prevState) => ({
        ...prevState,
        ...err,
      }));
    }
  });

  return iserror
};

export const createRangePipedelimited = (item) => {
  return [
    item.Range_Qualified[0][0],
    item.Range_Qualified[1][0],
    item.Range_Qualified[2][0],
    item.Range_Qualified[3][0],
    item.Range_Qualified[4][0],
    item.Range_Qualified[5][0],
    item.Range_Qualified[6][0],
  ]
    .filter((value) => value.trim() !== "") // Filter out empty strings
    .join(",") + "|"; // Join the remaining values with commas, then ad

}

export const createWPQObject = (item, key) => ({
  wld_createdon: item.wld_createdon || "",
  wld_WPSType: item.wld_WPSType,
  WPQ_WelderId: item.WPQ_WelderId,
  WPQ_RecordNo: item.WPQ_RecordNo,
  WPQ_Process: item.WPQ_Process,
  WPQ_Process_Category: item.WPQ_Process_Category,
  WPQ_Type: item.WPQ_Type,
  [key]: item[key],
});

export const saveImage = async (image, folder, setUrl, setimg, profile) => {

  if (image !== "") {

    const result = await getPresignedURL(
      folder,
      image
    );

    const posturl = result.url;
    setUrl(posturl);

    await axios.put(posturl, profile);


    setimg(true)

  }

}

export const getImage = async (item, folder, setUrl) => {
  if (item) {
    const result = await getPresignedURL(
      folder,
      item
    );

    const posturl = result.url;
    setUrl(posturl);
  }
}

export const handleCount = (changeno, action, Action) => {
  return isNaN(changeno) ? "1" : String(Number(changeno) + 1);
};

export const createWPQRangeQualPostlist = (detaildata) => {


  const keys = [
    "WPQ_Detail_Backing",
    "WPQ_FM_Arc_transfermode",
    "WPQ_Detail_Type",
    "WPQ_FM_Automatic_AVC_System",
    "WPQ_FM_Welding_Position",
    "WPQ_FM_Specification",
    "WPQ_FM_Classification",
    "WPQ_FM_filler_Wire",
    "WPQ_FM_F_No",
    "WPQ_FM_Consumable_Insert",
    "WPQ_FM_Product_Form",
    "WPQ_FM_No_of_LayerDeposit",
    "WPQ_FM_Thickness_Limit",
    "WPQ_FM_Progression",
    "WPQ_FM_Current_Polarity",
    "WPQ_FM_Backing_Gas",
    "WPQ_FM_Direct_VisualControl",
    "WPQ_FM_Automatic_jointTracking",
    "WPQ_FM_Single_Pass_PerSide",
    "WPQ_FM_Automatic_AVC_System",
    // "WPQ_FM_Notes",
    "WPQ_FM_Weld_Deposit_Thickness",
    "WPQ_Groove_610",
    "WPQ_Groove_73to610",
    "WPQ_Groove_73",
    "WPQ_Fillet_610",
    "WPQ_Fillet_73to610",
    "WPQ_Fillet_73",
    "WPQ_Overlay_610",
    "WPQ_Overlay_73to610",
    "WPQ_Overlay_73",
  ];

  const postList = [];

  for (const item of detaildata) {
    if (item.WPQ_Process != undefined && item.WPQ_Process != "") {
      keys.forEach((key) => {
        postList.push(createWPQObject(item, key));
      });


    }
  }
  console.log("Postlist", postList)
  return postList
}

export const setErrorRangeAndActual = (setError, column, msg) => {
  setError((prevState) => ({
    ...prevState,

    [column]: [
      {
        Actual_Value: [
          {
            status: true,
            message: msg,
          },
        ],
      },
      {
        Range_Qualified: [
          {
            status: true,
            message: msg,
          },
        ],
      },
    ],
  }));
}

/**
 * Calculate WPQ expiry date (178 days from last weld date)
 * @param {string} lastWeldDate - Date in DD-MM-YYYY format
 * @returns {string} Expiry date in YYYY-MM-DD format
 */
export const calculateWPQExpiryDate = (lastWeldDate) => {
  const [day, month, year] = lastWeldDate.split("-");
  const lastWeldDateObj = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
  const expiryDate = new Date(lastWeldDateObj.getTime() + (178 * 24 * 60 * 60 * 1000));
  return `${expiryDate.getFullYear()}-${String(expiryDate.getMonth() + 1).padStart(2, '0')}-${String(expiryDate.getDate()).padStart(2, '0')}`;
};